module.exports = __webpack_public_path__ + "img/ic_facebook.c33cf125.svg";